import React from 'react';

function Assinatura ({ text, children }) {
  return (
    <div
      style={{
        textAlign: 'center',
        borderTop: '1px solid',
        margin: '0 auto',
        marginBottom: '14px',
        marginTop: '50px',
        position: 'relative',
        width: '45%'
      }}
    >
      <span style={{ fontSize: '18px', fontWeight: 600 }}>{text}</span>
    </div>
  );
}

export default Assinatura;



// WEBPACK FOOTER //
// ./src/componentes/AssinaturaRodape/Assinatura/index.js